import { GridColDef } from "@mui/x-data-grid-pro"
import { Encrypt, FnAxios, FnDialog, I18n, RouterDOM } from "utilities/utilities";
import { BtnAddOnTableRender, DefaultParamCol } from "../Ticket/components/CreateColumnTable";
import { useEffect, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid';
import { I18NextNs } from "enum/enum";
import { useForm } from "react-hook-form";
import { numberFormatterLocale, renderCellUpdate } from "../Ticket/fnTickit";
import { GetMenuPermissionParamRoute } from "utilities/SystemFunction";
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from "components/Button/ButtonTable";

export function useFundAccouting() {

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();

    // const [nPrmUser, setNPrmUser] = useState(2);
    const [anchorEl, setAnchorEl] = useState(null);
    const [messagePopper, setMessagePopper] = useState("")
    const [loadingTable, setLoadingTable] = useState(false);
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sDate",
        sSortDirection: "desc",
    });

    //#region Form
    const formSearch = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundAccoutingList", AxiosFn, setIsPermission, DialogFn);
    }, []);


    useEffect(() => {
        getTable(dataRow);
    }, [])

    const getTable = (p: PaginationInterface) => {
        DialogFn.BlockUI();
        setLoadingTable(true);
        let Param = {
            ...p,
            arrRows: [],
            nDate: formSearch.getValues("dDate") ? formSearch.getValues("dDate").valueOf() : null,
        };
        AxiosFn.Post(`FundAccounting/GetTableFundAccount`, Param, (result) => {
            DialogFn.UnBlockUI();
            setLoadingTable(false);
            let objResult = result.objResult;
            setDataRow({
                ...p,
                arrRows: objResult.lstData,
                nDataLength: objResult.nDataLength,
                nPageIndex: objResult.nPageIndex,
            });
        });
    };
    const onDelete = (arrSelect) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), () => {
            DialogFn.BlockUI();
            setLoadingTable(true);
            AxiosFn.Post(`FundAccounting/OnDeleteTableFundAccount`, { lstId: arrSelect }, () => {
                getTable(dataRow)
                DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent));
                DialogFn.UnBlockUI();
            });
        });
    }

    const handleClearSearch = () => {
        formSearch.setValue("dDate", null);
        getTable(dataRow);
    };


    const dataColumn: GridColDef[] = [
        {
            ...DefaultParamCol,
            field: "cAction",
            width: 60,
            minWidth: 60,
            headerName: "",
            type: "actions",
            flex: 0,
            sortable: false,
            renderHeader: () => {
                if (isPermission) {
                    return (
                        <BtnAddOnTableRender
                            path={"/FundAccoutingForm"}
                            nPermision={isPermission ? 2 : 1}
                        />
                    );
                }
            },
            renderCell: (params) => {
                return (
                    <BtnEditOnTableRenderFundAcc
                        path={"/FundAccoutingForm"}
                        params={params}
                        nPermision={params.row.isView || !isPermission ? 1 : 2}
                    />
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sDate",
            headerName: `ประจำเดือน ปี`,
        },
        {
            ...DefaultParamCol,
            field: "nTotalIncome",
            headerName: `รวมรายรับ`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nTotalExpense",
            headerName: `รวมรายจ่าย`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nBringForward",
            headerName: `เงินคงเหลือ ณ ต้นงวด`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "nBalance",
            headerName: `เงินคงเหลือ ณ ปลายงวด`,
            align: "right",
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {numberFormatterLocale(params.value, 2)}
                    </>
                );
            },
        },
        {
            ...DefaultParamCol,
            field: "sStatus",
            headerName: `สถานะ`,
            flex: 1,
        },
        {
            ...DefaultParamCol,
            field: "sUpdate",
            headerName: `วันที่แก้ไขล่าสุด`,
            flex: 1.5,
            renderCell: (params) => {
                return (
                    <>
                        {renderCellUpdate(params, handleClickUpdate)}
                    </>
                )
            }
        }
    ];

    const handleClickUpdate = (event, params) => {
        setAnchorEl(event.currentTarget);
        setMessagePopper(params.row.sUpdateName)
    };

    return {
        isPermission,
        formSearch,
        dataColumn,
        getTable,
        onDelete,
        handleClearSearch,
        dataRow,
        loadingTable,
        anchorEl,
        setAnchorEl,
        messagePopper,
    };
}

export const BtnAddOnTableRenderFundAcc = ({ path,nPermision }) => {
    const Router = RouterDOM();

    const gotoPage = () => {
        if (nPermision) {
            let key = "?nPermision=" + Encrypt(nPermision)
            path += key;
        }
        Router.GoToPage(path);
    }

    return (
        <BtnAddOnTable
            id={'go-form'}
            onClick={() => gotoPage()}
        />
    )
}


 const BtnEditOnTableRenderFundAcc = ({ path,params,nPermision }) => {
    const Router = RouterDOM();

    const gotoPage = () => {
        if (params) {
            let key = "?strParam=" + params.row.sID
            path += key;

            if(nPermision)
            {
                path += "&nPermision=" + Encrypt(nPermision);
            }
        }
        Router.GoToPage(path);
    }

    if(nPermision === 1)
    {
        return (
            <BtnViewOnTable
                id={'go-form'}
                onClick={() => gotoPage()}
            />
        )
    }
    return (
        <BtnEditOnTable
            id={'go-form'}
            onClick={() => gotoPage()}
        />
    )
}